const common = {
  'common.copy': 'Copy',
  'common.or': 'or',
  'common.mandatory': 'Required',
  'common.not.mandatory': 'Optional',
  'common.details': 'Details',
  'common.close': 'Close',
  'common.more': 'More',
  'common.retry': 'Retry',
  'common.causes': 'Possible causes',
  'common.copied_to_clipboard': 'Copied to clipboard!',
  'common.copy_failed': 'Copy failed',
  'common.yes': 'Yes',
  'common.no': 'No',
};

const action = {
  'action.cancel': 'Cancel',
  'action.back': 'Back',
  'action.come_back_later': 'Come back later',
  'action.filter': 'Filter',
  'action.send': 'Send',
  'action.delete': 'Delete',
  'action.confirm': 'Confirm',
};

const api = {
  'api.error': 'An error occurred, please try again later.',
};

const homepage = {
  'homepage.welcome': 'Welcome to Vera',
  'homepage.subtitle': 'Dematerialization Management Platform',
  'homepage.description':
    'Vera is your centralized tool to manage PIXID dematerialization settings and contracts for your clients. Designed for operational teams who need efficiency, traceability and simplicity.',
  'homepage.modern_interface': 'Intuitive Interface',
  'homepage.modern_interface_description':
    'Simple navigation and quick actions for your productivity',
  'homepage.feature.title': 'Key Features',
  'homepage.feature.description':
    'Efficiently manage your dematerialization settings and contracts with dedicated tools.',
  'homepage.feature.pixid_config': 'PIXID Configuration',
  'homepage.feature.contracts_management': 'Contract Management',
  'homepage.feature.multi_platform': 'Multi-Platform',
  'homepage.feature.favorites': 'Favorite Searches',
  'homepage.feature.pixid_config_description':
    'Configure and view client dematerialization settings by tenant and platform.',
  'homepage.feature.contracts_management_description':
    'Access and manage the complete list of contracts with advanced filters by status, reference and agency.',
  'homepage.feature.orders_management': 'Orders Management',
  'homepage.feature.orders_management_description':
    'View and filter all orders with advanced search options by number, agency, and dates.',
  'homepage.feature.multi_platform_description':
    'Work across multiple platforms and tenants by easily switching between environments.',
  'homepage.feature.favorites_description':
    'Save your frequent searches for quick access to the most consulted client configurations.',
  'homepage.platforms': 'Platforms',
  'homepage.tenants': 'Tenants',
  'homepage.support': 'Support',
  'homepage.greeting': 'Hello {{name}}',
  'homepage.shortcuts.title': 'Quick access',
  'homepage.shortcut.pixid-contracts':
    'Browse contracts by platform, tenant, status and reference.',
  'homepage.shortcut.pixid-orders':
    'Search orders by number, agency and dates.',
  'homepage.shortcut.pixid-resources':
    'Find temporary workers and their contracts by platform.',
  'homepage.shortcut.pixid-param-demat':
    'Client dematerialization settings by tenant and agency.',
  'homepage.shortcut.rubriques-clients':
    'Mapping of client headings to Anael values.',
  'homepage.shortcut.document-mapping': 'Document mapping between platforms.',
  'homepage.shortcut.client-vms-config': 'Client VMS configuration by agency.',
  'homepage.clients': 'Clients',
};

const headerMenu = {
  'header.menu.home': 'Home',
  'header.menu.config': 'Configuration',
  'header.menu.config.heading_clients': 'Client Headings',
  'header.menu.config.document_mapping': 'Document Mapping',
  'header.menu.config.client_vms_config': 'Client VMS Configuration',
  'header.menu.dashboard': 'Dashboard',
  'header.menu.pixid': 'Pixid Platform',
  'header.menu.pixid_dashboard': 'Client Parameters',
  'header.menu.pixid_contracts_dashboard': 'Contracts',
  'header.menu.pixid_orders_dashboard': 'Orders',
  'header.menu.pixid_resources_dashboard': 'Temporary Workers',
};

const footer = {
  'footer.company.legal_notice':
    'Confidential information for internal use only.',
  'footer.development': 'Developed with ❤️ by the Digital Factory.',
  'footer.last_update': 'Last update: {{- date }}',
};

const footerMenu = {
  'footer.menu.resources.title': 'Resources',
  'footer.menu.support.title': 'Support',
  'footer.menu.company.title': 'Company',
  'footer.menu.resources.documentation': 'Documentation',
  'footer.menu.resources.api': 'API Reference',
  'footer.menu.resources.guide': 'Getting Started Guide',
  'footer.menu.support.help_center': 'Help Center',
  'footer.menu.support.contact_team': 'Contact Team',
  'footer.menu.support.bug': 'Report a Bug',
  'footer.menu.company.about': 'About',
  'footer.menu.company.digital': 'Digital Factory',
  'footer.menu.company.confidentiality': 'Privacy',
};

const notifications = {
  'notifications.login.success': 'Login successful! Welcome {{- name }}',
  'notifications.logout.success':
    'Logout successful. See you soon {{- name }}!',
  'notifications.error': 'An error occurred',
};

const userMenu = {
  'user.menu.login': 'Sign in',
  'user.menu.logining': 'Signing in...',
  'user.menu.logout': 'Sign out',
  'user.menu.language': 'Language',
  'user.menu.language_en': 'English',
  'user.menu.language_fr': 'Français',
  'user.menu.account': 'My account',
};

const layout = {
  'layout.sidebar.collapse': 'Collapse menu',
  'layout.sidebar.expand': 'Expand menu',
  'layout.sidebar.toggle': 'Toggle menu',
  'layout.sidebar.title': 'Main menu',
  'layout.sidebar.description': 'Navigation between the application pages.',
};

const authError = {
  'auth.error.401': 'Authentication Required',
  'auth.error.403': 'Access Denied',
  'auth.error.404': 'Authentication Service Not Found',
  'auth.error.500': 'Server Error',
  'auth.error.default': 'Authentication Failed',
  'auth.error.scud.token': 'Your SCUD token has expired',
  'auth.error.scud.permission':
    'You do not have permission to access this application',
  'auth.error.scud.unavailable': 'The SCUD API is temporarily unavailable',
  'auth.error.reason.network': 'Network connectivity issues',
  'auth.error.unauthorized':
    'Your account may not be authorized for this service',
  'auth.error.scud.permission_changed':
    'Your roles/permissions may have changed',
  'auth.error.scud.api': 'The SCUD API is experiencing technical difficulties',
  'auth.error.mainetanance': 'Server maintenance may be in progress',
  'auth.error.interuption': 'Temporary service interruption',
  'auth.error.try_again': 'Clear Auth and Try Again',
  'auth.error.development_mode':
    '💡 Tip: Add {{ code }} to your .env file to bypass authentication in development',
  'auth.error.id_request': 'Request ID',
  'auth.error.too_many_attempts': 'Too many authentication attempts',
  'auth.error.too_many_attempts_description':
    'We have tried to authenticate you {{- attempts }} times without success. To avoid an infinite loop, we have stopped trying.',
  'auth.error.too_many_attempts_suggestion': 'Recommended steps',
  'auth.error.reset_retry': 'Reset and Retry',
  'auth.error.ignore_auth': 'Ignore Auth (Dev)',
  'auth.error.clear_data': 'Clear All Browser Data and Retry',
  'auth.error.contact_admin':
    'If this problem persists, please contact your system administrator',
  'auth.error.attempts.scud': 'Check your SCUD access',
  'auth.error.attempts.scud_description':
    'Make sure you have valid credentials and permissions for SCUD authentication',
  'auth.error.attempts.browser': 'Clear browser data',
  'auth.error.attempts.browser_description':
    'Clear cookies and local storage for this site if the problem persists',
  'auth.error.attempts.contact': 'Contact support',
  'auth.error.attempts.contact_description':
    'If the problem persists, contact your IT administrator',
  'auth.error.attempts.loop': 'Authentication loop detected',
  'auth.error.attempts.text': 'attempts',
};

const dashboard = {
  'dashboard.title': 'Dashboard',
  'dashboard.filters.title': 'Filters',
  'dashboard.filters.reset': 'Reset filters',
};

const pixidDashboard = {
  'dashboard.pixid.title': 'Client Parameters',
  'dashboard.pixid.select_tenant': 'Select a Tenant',
  'dashboard.pixid.select_agency': 'Select an Agency',
  'dashboard.pixid.select_client': 'Select a Client',
  'dashboard.pixid.selection.title': 'Agency and client',
  'dashboard.pixid.search_agency_hint':
    'Type at least 2 characters to search for an agency',
  'dashboard.pixid.search_client_hint':
    'Type at least 2 characters to search for a client',
  'dashboard.pixid.validate': 'Validate',
  'dashboard.pixid.loading': 'Loading data',
  'dashboard.pixid.client.legal_id': 'Legal ID',
  'dashboard.pixid.client.address': 'Address',
  'dashboard.pixid.favorites.title': 'Favorite searches',
  'dashboard.pixid.favorites.description':
    'You have {{count}} favorite search(es)',
  'dashboard.pixid.favorites.add': 'Add to favorites',
  'dashboard.pixid.favorites.remove': 'Remove from favorites',
  'dashboard.pixid.favorites.platform': 'Platform',
  'dashboard.pixid.favorites.tenant': 'Tenant',
  'dashboard.pixid.favorites.section_clients': 'CLIENT PARAMETERS SEARCH',
  'dashboard.pixid.favorites.section_contracts': 'CONTRACTS SEARCH',
  'dashboard.pixid.favorites.section_orders': 'ORDERS SEARCH',
  'dashboard.pixid.favorites.section_resources': 'RESOURCES SEARCH',
  'dashboard.pixid.favorites.section_heading_clients': 'CLIENT HEADINGS SEARCH',
  'dashboard.pixid.favorites.section_document_mapping':
    'DOCUMENT MAPPING SEARCH',
  'dashboard.pixid.favorites.filters_count': '{{count}} filter(s)',
  'dashboard.pixid.table.code': 'Code',
  'dashboard.pixid.table.type': 'Type',
  'dashboard.pixid.table.designation': 'Designation',
  'dashboard.pixid.table.label': 'Label',
  'dashboard.pixid.table.platform': 'Platform',
  'dashboard.pixid.no_params': 'No parameters found for this client.',
  'dashboard.pixid.no_results': 'No results match your search criteria.',
  'dashboard.pixid.filters.title': 'Filters',
  'dashboard.pixid.filters.reset': 'Reset filters',
  'dashboard.pixid.filters.code': 'Code',
  'dashboard.pixid.filters.designation': 'Designation',
  'dashboard.pixid.filters.label': 'Label',
  'dashboard.pixid.empty.title': 'Start your search',
  'dashboard.pixid.empty.description':
    'Select a tenant, an agency and a client to display parameters.',
  'dashboard.pixid.errors.fetch_platforms': 'Error fetching platforms.',
  'dashboard.pixid.errors.fetch_tenants': 'Error fetching tenants.',
  'dashboard.pixid.errors.fetch_agencies': 'Error fetching agencies.',
  'dashboard.pixid.errors.fetch_clients': 'Error fetching clients.',
  'dashboard.pixid.errors.fetch_client_params':
    'Error fetching client parameters.',
  'dashboard.pixid.errors.fetch_parameter_types':
    'Error fetching parameter types.',
  'dashboard.pixid.errors.no_platform':
    'No platform available. Please contact an administrator.',
  'dashboard.pixid.pagination.total': 'parameters',
  'dashboard.pixid.pagination.per_page': 'parameters per page',
};

const contractsDashboard = {
  'dashboard.contracts.title': 'Contracts',
  'dashboard.contracts.select_platform': 'Platform',
  'dashboard.contracts.select_tenant': 'Select a Tenant',
  'dashboard.contracts.loading': 'Loading contracts',
  'dashboard.contracts.filters.title': 'Filters',
  'dashboard.contracts.filters.reference': 'Reference',
  'dashboard.contracts.filters.status': 'Status',
  'dashboard.contracts.filters.agency_code': 'Agency Code',
  'dashboard.contracts.filters.amendment_number': 'Amendment Number',
  'dashboard.contracts.filters.created_at': 'Created at',
  'dashboard.contracts.filters.updated_at': 'Updated at',
  'dashboard.contracts.filters.sent_at': 'Sent at',
  'dashboard.contracts.filters.apply': 'Apply filters',
  'dashboard.contracts.filters.reset': 'Reset',
  'dashboard.contracts.table.id': 'ID',
  'dashboard.contracts.table.reference': 'Reference',
  'dashboard.contracts.table.agency_code': 'Agency Code',
  'dashboard.contracts.table.status': 'Status',
  'dashboard.contracts.table.amendment_number': 'Amendment Number',
  'dashboard.contracts.table.created_at': 'Created at',
  'dashboard.contracts.table.updated_at': 'Updated at',
  'dashboard.contracts.table.sent_to': 'Sent to',
  'dashboard.contracts.table.sent_by': 'Sent by',
  'dashboard.contracts.table.sent_at': 'Sent at',
  'dashboard.contracts.table.errors': 'Errors',
  'dashboard.contracts.table.view_errors': 'View errors',
  'dashboard.contracts.table.data': 'Data',
  'dashboard.contracts.table.view_data': 'View data',
  'dashboard.contracts.table.order': 'Order',
  'dashboard.contracts.table.view_order': 'View order',
  'dashboard.contracts.table.toggle_columns': 'Toggle columns visibility',
  'dashboard.contracts.table.toggle_all': 'Toggle all',
  'dashboard.contracts.table.columns_visible': 'visible columns',
  'dashboard.contracts.table.manage_columns': 'Manage columns',
  'dashboard.contracts.table.column_management': 'Column Management',
  'dashboard.contracts.table.customize_display': 'Customize table display',
  'dashboard.contracts.table.hide_all': 'Hide all',
  'dashboard.contracts.table.show_all': 'Show all',
  'dashboard.contracts.table.columns_count': 'visible column(s)',
  'dashboard.contracts.table.close': 'Close',
  'dashboard.contracts.table.filename': 'Filename',
  'dashboard.contracts.table.platform_contract_id': 'VMS contract ID',
  // Contract statuses
  'dashboard.contracts.status.pending': 'Pending',
  'dashboard.contracts.status.deposited': 'Deposited',
  'dashboard.contracts.status.inconsistent': 'Inconsistent',
  'dashboard.contracts.status.signed': 'Signed',
  'dashboard.contracts.status.stored': 'Stored',
  'dashboard.contracts.status.archived': 'Archived',
  'dashboard.contracts.status.canceled': 'Canceled',
  'dashboard.contracts.status.failed': 'Failed',
  'dashboard.contracts.no_data': 'No contracts found.',
  'dashboard.contracts.empty.title': 'No contracts available',
  'dashboard.contracts.empty.description':
    'Select a tenant to display contracts.',
  'dashboard.contracts.errors.fetch_contracts': 'Error fetching contracts.',
  'dashboard.contracts.errors.no_tenant': 'Please select a tenant.',
  'dashboard.contracts.pagination.rows_per_page': 'Rows per page',
  'dashboard.contracts.pagination.of': 'of',
  'dashboard.contracts.pagination.total': 'contracts',
  'dashboard.contracts.pagination.per_page': 'contracts per page',
  'dashboard.contracts.favorites.add': 'Add to favorites',
  'dashboard.contracts.favorites.remove': 'Remove from favorites',
  'dashboard.contracts.favorites.active_filters': 'Active filters',
  'dashboard.contracts.errors_modal.title': 'Error Details',
  'dashboard.contracts.errors_modal.contract_number': 'Contract #',
  'dashboard.contracts.errors_modal.last_occurrence': 'Last occurrence:',
  'dashboard.contracts.errors_modal.fails_title': 'Failures',
  'dashboard.contracts.errors_modal.inconsistencies_title': 'Inconsistencies',
  'dashboard.contracts.errors_modal.heading': 'Heading: ',
  'dashboard.contracts.errors_modal.field': 'Field',
  'dashboard.contracts.errors_modal.order': 'Order',
  'dashboard.contracts.errors_modal.contract': 'Contract',
  'dashboard.contracts.related_order_modal.title': 'Related order',
  'dashboard.contracts.related_order_modal.navigate': 'Open in orders',
  // Deposit
  'dashboard.contracts.table.actions': 'Actions',
  'dashboard.contracts.table.deposit': 'Redeposit contract',
  'dashboard.contracts.deposit.success': 'Contract successfully redeposited',
  'dashboard.contracts.deposit.error': 'Error redepositing contract',
};

const ordersDashboard = {
  'dashboard.orders.title': 'Orders',
  'dashboard.orders.select_platform': 'Platform',
  'dashboard.orders.select_tenant': 'Select a Tenant',
  'dashboard.orders.loading': 'Loading orders',
  'dashboard.orders.filters.title': 'Filters',
  'dashboard.orders.filters.reference': 'Order Number',
  'dashboard.orders.filters.agency_code': 'Agency Code',
  'dashboard.orders.filters.created_at': 'Created at',
  'dashboard.orders.filters.updated_at': 'Updated at',
  'dashboard.orders.filters.reset': 'Reset filters',
  'dashboard.orders.table.id': 'ID',
  'dashboard.orders.table.agency_code': 'Agency Code',
  'dashboard.orders.table.siret': 'SIRET',
  'dashboard.orders.table.reference': 'Order Number',
  'dashboard.orders.table.platform': 'Platform',
  'dashboard.orders.table.tenant': 'Tenant',
  'dashboard.orders.table.created_at': 'Created at',
  'dashboard.orders.table.updated_at': 'Updated at',
  'dashboard.orders.table.data': 'Data',
  'dashboard.orders.table.view_data': 'View data',
  'dashboard.orders.table.contract': 'Contract',
  'dashboard.orders.table.view_contract': 'View contract',
  'dashboard.orders.related_contract_modal.title': 'Related contract',
  'dashboard.orders.related_contract_modal.navigate': 'Open in contracts',
  'dashboard.orders.table.columns_visible': 'columns visible',
  'dashboard.orders.table.toggle_columns': 'Manage columns',
  'dashboard.orders.table.manage_columns': 'Manage columns',
  'dashboard.orders.table.platform_order_id': 'VMS order ID',
  'dashboard.orders.no_data': 'No orders found.',
  'dashboard.orders.empty.title': 'No orders found',
  'dashboard.orders.empty.description': 'Select a tenant to display orders.',
  'dashboard.orders.empty.no_matching_filters':
    'No orders match the applied filters',
  'dashboard.orders.empty.not_available': 'No orders available',
  'dashboard.orders.errors.fetch_orders': 'Error fetching orders.',
  'dashboard.orders.pagination.total': 'orders',
  'dashboard.orders.pagination.per_page': 'orders per page',
  'dashboard.orders.favorites.add': 'Add to favorites',
  'dashboard.orders.favorites.remove': 'Remove from favorites',
  'dashboard.orders.favorites.active_filters': 'Active filters',
};

const resourcesDashboard = {
  'dashboard.resources.title': 'Temporary Workers',
  'dashboard.resources.select_platform': 'Platform',
  'dashboard.resources.select_tenant': 'Select a Tenant',
  'dashboard.resources.loading': 'Loading temporary workers',
  'dashboard.resources.filters.title': 'Filters',
  'dashboard.resources.filters.firstname': 'First Name',
  'dashboard.resources.filters.lastname': 'Last Name',
  'dashboard.resources.filters.email': 'Email',
  'dashboard.resources.filters.phone': 'Phone',
  'dashboard.resources.filters.created_at': 'Created at',
  'dashboard.resources.filters.updated_at': 'Updated at',
  'dashboard.resources.filters.sent_at': 'Sent at',
  'dashboard.resources.filters.reset': 'Reset filters',
  'dashboard.resources.table.id': 'ID',
  'dashboard.resources.table.firstname': 'First Name',
  'dashboard.resources.table.lastname': 'Last Name',
  'dashboard.resources.table.email': 'Email',
  'dashboard.resources.table.phone': 'Phone',
  'dashboard.resources.table.platform_resource_id': 'Resource ID',
  'dashboard.resources.table.sent_to': 'Sent to',
  'dashboard.resources.table.sent_by': 'Sent by',
  'dashboard.resources.table.sent_at': 'Sent at',
  'dashboard.resources.table.created_at': 'Created at',
  'dashboard.resources.table.updated_at': 'Updated at',
  'dashboard.resources.table.contracts': 'Contracts',
  'dashboard.resources.table.view_contracts': 'View contracts',
  'dashboard.resources.table.view_contract_details': 'View contract details',
  'dashboard.resources.table.data': 'Data',
  'dashboard.resources.table.view_data': 'View data',
  'dashboard.resources.table.toggle_columns': 'Toggle columns visibility',
  'dashboard.resources.table.columns_visible': 'visible columns',
  'dashboard.resources.no_data': 'No temporary workers found.',
  'dashboard.resources.errors.fetch_resources':
    'Error fetching temporary workers.',
  'dashboard.resources.pagination.total': 'temporary workers',
  'dashboard.resources.pagination.per_page': 'temporary workers per page',
  'dashboard.resources.favorites.add': 'Add to favorites',
  'dashboard.resources.favorites.remove': 'Remove from favorites',
  'dashboard.resources.favorites.active_filters': 'Active filters',
};

const headingClientsDashboard = {
  'dashboard.heading_clients.title': 'Heading Clients',
  'dashboard.heading_clients.no_data': 'No heading client found',
  'dashboard.heading_clients.no_matching_filters':
    'No heading client match the applied filters',
  'dashboard.heading_clients.not_available': 'No heading client available',
  'dashboard.heading_clients.filters.code': 'Code',
  'dashboard.heading_clients.filters.agency_code': 'Agency code',
  'dashboard.heading_clients.filters.client_code': 'Client code',
  'dashboard.heading_clients.filters.anael_value': 'Anael value',
  'dashboard.heading_clients.filters.platform_value': 'Platform value',
  'dashboard.heading_clients.errors.fetch_heading_clients':
    'Error fetching heading clients.',
  'dashboard.heading_clients.errors.import':
    'File import failed. Please try again.',
  'dashboard.heading_clients.import.success':
    'Heading clients successfully imported',
  'dashboard.heading_clients.pagination.total': 'headings',
  'dashboard.heading_clients.pagination.per_page': 'headings per page',
  'dashboard.heading_clients.table.import': 'Import',
  'dashboard.heading_clients.table.import_tooltip':
    'Import headings from a file',
  'dashboard.heading_clients.table.import_anael': 'Import from Anael',
  'dashboard.heading_clients.table.import_anael_tooltip':
    'Import headings from Anael',
  'dashboard.heading_clients.table.id': 'ID',
  'dashboard.heading_clients.table.platform': 'Plateform',
  'dashboard.heading_clients.table.agency_code': 'Agency code',
  'dashboard.heading_clients.table.client_code': 'Client code',
  'dashboard.heading_clients.table.code': 'Code',
  'dashboard.heading_clients.table.anael_value': 'Anael value',
  'dashboard.heading_clients.table.platform_value': 'Platform value',
  'dashboard.heading_clients.table.created_at': 'Created at',
  'dashboard.heading_clients.table.updated_at': 'Updated at',
  'dashboard.heading_clients.select_platform': 'Platform',
  'dashboard.heading_clients.favorites.add': 'Add this search to favorites',
  'dashboard.heading_clients.favorites.remove':
    'Remove this search from favorites',
  'dashboard.heading_clients.favorites.active_filters': 'Active filters',
  'dashboard.heading_clients.table.actions': 'Actions',
  'dashboard.heading_clients.table.edit': 'Edit',
  'dashboard.heading_clients.table.delete': 'Delete',
  'dashboard.heading_clients.table.download_rubrics': 'Download rubrics file',
  'dashboard.heading_clients.download.error': 'Error downloading rubrics file',
  'dashboard.heading_clients.create.button': 'Create a heading client',
  'dashboard.heading_clients.create.title': 'Create a Heading Client',
  'dashboard.heading_clients.create.success':
    'Heading client created successfully',
  'dashboard.heading_clients.create.error': 'Error creating heading client',
  'dashboard.heading_clients.create.submit': 'Create',
  'dashboard.heading_clients.create.cancel': 'Cancel',
  'dashboard.heading_clients.create.field.agency_code': 'Agency code',
  'dashboard.heading_clients.create.field.client_code': 'Client code',
  'dashboard.heading_clients.create.field.code': 'Code',
  'dashboard.heading_clients.create.field.anael_value': 'Anael value',
  'dashboard.heading_clients.create.field.platform_value': 'Platform value',
  'dashboard.heading_clients.create.field.platform': 'Platform',
  'dashboard.heading_clients.edit.title': 'Edit Heading Client',
  'dashboard.heading_clients.edit.success':
    'Heading client updated successfully',
  'dashboard.heading_clients.edit.error': 'Error updating heading client',
  'dashboard.heading_clients.edit.submit': 'Save',
  'dashboard.heading_clients.edit.cancel': 'Cancel',
  'dashboard.heading_clients.delete.success':
    'Heading client deleted successfully',
  'dashboard.heading_clients.delete.error': 'Error deleting heading client',
  'dashboard.heading_clients.delete.confirm.title': 'Confirm Deletion',
  'dashboard.heading_clients.delete.confirm.message':
    'Are you sure you want to delete this heading client? This action cannot be undone.',
  'dashboard.heading_clients.delete.confirm.yes': 'Delete',
  'dashboard.heading_clients.delete.confirm.no': 'Cancel',
};

const documentMappingDashboard = {
  'dashboard.document_mapping.title': 'Document Mapping',
  'dashboard.document_mapping.no_data': 'No document found',
  'dashboard.document_mapping.no_matching_filters':
    'No document match the applied filters',
  'dashboard.document_mapping.not_available': 'No document available',
  'dashboard.document_mapping.filters.code': 'Code',
  'dashboard.document_mapping.filters.category': 'Category',
  'dashboard.document_mapping.filters.code_vms': 'VMS Code',
  'dashboard.document_mapping.filters.category_vms': 'VMS Category',
  'dashboard.document_mapping.filters.label': 'Label',
  'dashboard.document_mapping.filters.platform': 'Plateform',
  'dashboard.document_mapping.filters.is_gdpr': 'GDPR',
  'dashboard.document_mapping.errors.fetch_document_mapping':
    'Error fetching documents.',
  'dashboard.document_mapping.pagination.total': 'documents',
  'dashboard.document_mapping.pagination.per_page': 'documents per page',
  'dashboard.document_mapping.table.id': 'ID',
  'dashboard.document_mapping.table.code': 'Code',
  'dashboard.document_mapping.table.category': 'Category',
  'dashboard.document_mapping.table.code_vms': 'VMS Code',
  'dashboard.document_mapping.table.category_vms': 'VMS Category',
  'dashboard.document_mapping.table.label': 'Label',
  'dashboard.document_mapping.table.platform': 'Plateform',
  'dashboard.document_mapping.table.is_gdpr': 'GDPR',
  'dashboard.document_mapping.table.created_at': 'Created at',
  'dashboard.document_mapping.table.updated_at': 'Updated at',
  'dashboard.document_mapping.select_platform': 'Plateform',
  'dashboard.document_mapping.favorites.add': 'Add this search to favorites',
  'dashboard.document_mapping.favorites.remove':
    'Remove this search from favorites',
  'dashboard.document_mapping.favorites.active_filters': 'Active filters',
  'dashboard.document_mapping.create.button': 'Create a mapping',
  'dashboard.document_mapping.create.title': 'Create a Document Mapping',
  'dashboard.document_mapping.create.success':
    'Document mapping created successfully',
  'dashboard.document_mapping.create.error': 'Error creating document mapping',
  'dashboard.document_mapping.create.submit': 'Create',
  'dashboard.document_mapping.create.cancel': 'Cancel',
  'dashboard.document_mapping.create.field.code': 'Code',
  'dashboard.document_mapping.create.field.category': 'Category',
  'dashboard.document_mapping.create.field.code_vms': 'VMS Code',
  'dashboard.document_mapping.create.field.category_vms': 'VMS Category',
  'dashboard.document_mapping.create.field.label': 'Label',
  'dashboard.document_mapping.create.field.platform': 'Platform',
  'dashboard.document_mapping.create.field.is_gdpr': 'Protected by GDPR',
  'dashboard.document_mapping.edit.title': 'Edit Document Mapping',
  'dashboard.document_mapping.edit.success':
    'Document mapping updated successfully',
  'dashboard.document_mapping.edit.error': 'Error updating document mapping',
  'dashboard.document_mapping.edit.submit': 'Save',
  'dashboard.document_mapping.edit.cancel': 'Cancel',
  'dashboard.document_mapping.table.actions': 'Actions',
  'dashboard.document_mapping.table.edit': 'Edit',
  'dashboard.document_mapping.table.delete': 'Delete',
  'dashboard.document_mapping.delete.success':
    'Document mapping deleted successfully',
  'dashboard.document_mapping.delete.error': 'Error deleting document mapping',
  'dashboard.document_mapping.delete.confirm.title': 'Confirm Deletion',
  'dashboard.document_mapping.delete.confirm.message':
    'Are you sure you want to delete this document mapping? This action cannot be undone.',
  'dashboard.document_mapping.delete.confirm.yes': 'Delete',
  'dashboard.document_mapping.delete.confirm.no': 'Cancel',
};

const clientVmsConfigDashboard = {
  'dashboard.client_vms_config.title': 'Client VMS Configuration',
  'dashboard.client_vms_config.no_data': 'No client VMS configuration found',
  'dashboard.client_vms_config.no_matching_filters':
    'No configuration matches the applied filters',
  'dashboard.client_vms_config.not_available':
    'No client VMS configuration available',
  'dashboard.client_vms_config.filters.agency_code': 'Agency code',
  'dashboard.client_vms_config.filters.client_code': 'Client code',
  'dashboard.client_vms_config.filters.siret': 'SIRET',
  'dashboard.client_vms_config.filters.platform': 'Platform',
  'dashboard.client_vms_config.filters.tenant': 'Tenant',
  'dashboard.client_vms_config.errors.fetch':
    'Error while fetching client VMS configurations.',
  'dashboard.client_vms_config.pagination.total': 'configurations',
  'dashboard.client_vms_config.pagination.per_page': 'configurations per page',
  'dashboard.client_vms_config.table.id': 'ID',
  'dashboard.client_vms_config.table.agency_code': 'Agency code',
  'dashboard.client_vms_config.table.client_code': 'Client code',
  'dashboard.client_vms_config.table.siret': 'SIRET',
  'dashboard.client_vms_config.table.platform': 'Platform',
  'dashboard.client_vms_config.table.tenant': 'Tenant',
  'dashboard.client_vms_config.table.created_at': 'Created at',
  'dashboard.client_vms_config.table.updated_at': 'Updated at',
  'dashboard.client_vms_config.table.actions': 'Actions',
  'dashboard.client_vms_config.table.edit': 'Edit',
  'dashboard.client_vms_config.table.delete': 'Delete',
  'dashboard.client_vms_config.create.button': 'Create a configuration',
  'dashboard.client_vms_config.create.title':
    'Create a Client VMS Configuration',
  'dashboard.client_vms_config.create.success':
    'Client VMS configuration created successfully',
  'dashboard.client_vms_config.create.error':
    'Error while creating the client VMS configuration',
  'dashboard.client_vms_config.create.submit': 'Create',
  'dashboard.client_vms_config.create.cancel': 'Cancel',
  'dashboard.client_vms_config.create.field.agency_code': 'Agency code',
  'dashboard.client_vms_config.create.field.client_code': 'Client code',
  'dashboard.client_vms_config.create.field.siret': 'SIRET',
  'dashboard.client_vms_config.create.field.platform': 'Platform',
  'dashboard.client_vms_config.create.field.tenant': 'Tenant',
  'dashboard.client_vms_config.edit.title': 'Edit Client VMS Configuration',
  'dashboard.client_vms_config.edit.success':
    'Client VMS configuration updated successfully',
  'dashboard.client_vms_config.edit.error':
    'Error while updating the client VMS configuration',
  'dashboard.client_vms_config.edit.submit': 'Save',
  'dashboard.client_vms_config.edit.cancel': 'Cancel',
  'dashboard.client_vms_config.delete.success':
    'Client VMS configuration deleted successfully',
  'dashboard.client_vms_config.delete.error':
    'Error while deleting the client VMS configuration',
  'dashboard.client_vms_config.delete.confirm.title': 'Confirm deletion',
  'dashboard.client_vms_config.delete.confirm.message':
    'Are you sure you want to delete this client VMS configuration? This action cannot be undone.',
  'dashboard.client_vms_config.delete.confirm.yes': 'Delete',
  'dashboard.client_vms_config.delete.confirm.no': 'Cancel',
};

const error = {
  'error.404.title': 'Page Not Found',
  'error.404.description': 'The page you are looking for does not exist.',
  'error.404.action.home': 'Go to Homepage',
  'error.boundary.title': 'Something went wrong',
  'error.boundary.description':
    'An unexpected error occurred. Reload the page to continue.',
  'error.boundary.reload': 'Reload page',
};

const pageTitle = {
  'page.title.home': 'Home',
  'page.title.dashboard': 'Dashboard',
  'page.title.testcafe_builder': 'TestCafe Builder',
  'page.title.not_found': 'Page not found',
  'page.title.app_name': 'Vera',
};

const platform = {
  'platform.access_denied.title': 'Access Denied',
  'platform.access_denied.message':
    'You do not have access to the {{platform}} platform.',
  'platform.access_denied.contact':
    'Please contact your administrator to obtain the necessary permissions.',
};

const table = {
  'table.empty': 'No results',
  'table.columns.count': '{{visible}} / {{total}} columns',
  'table.columns.manage': 'Manage columns',
  'table.columns.toggle_all': 'Show all',
  'table.row_actions': 'Actions',
};

const pagination = {
  'pagination.page_size': 'Results per page',
  'pagination.per_page': 'per page',
  'pagination.of': 'of',
  'pagination.previous': 'Previous page',
  'pagination.next': 'Next page',
};

const combobox = {
  'combobox.search': 'Search…',
  'combobox.empty': 'No results',
  'combobox.loading': 'Loading…',
  'combobox.placeholder': 'Select',
  'combobox.clear': 'Clear',
};

const select = {
  'select.all': 'All',
};

const defaultExport = {
  ...common,
  ...action,
  ...combobox,
  ...select,
  ...api,
  ...homepage,
  ...headerMenu,
  ...footer,
  ...footerMenu,
  ...notifications,
  ...userMenu,
  ...layout,
  ...authError,
  ...dashboard,
  ...pixidDashboard,
  ...contractsDashboard,
  ...ordersDashboard,
  ...resourcesDashboard,
  ...headingClientsDashboard,
  ...documentMappingDashboard,
  ...clientVmsConfigDashboard,
  ...error,
  ...pageTitle,
  ...platform,
  ...table,
  ...pagination,
};

export default defaultExport;
